
class BESSAppDoingWorkBlockingModal extends  BESSAppModal {

    constructor(title, message) {
        super('app-doing-work-blocking-modal');
        this.setTitle(title);
        this.setMessage(message);
        this.open();
    }
}